import { Input } from "@/components/ui/input";
import { toCleanNumericString, sanitizeNumericDigits, formatTurkishThousands } from "@/lib/numericInput";

/**
 * Faz 3 - paylaşılan sayısal giriş bileşeni. Mevcut Shadcn `Input` üzerine ince
 * bir katman: kullanıcı ne yazarsa yazsın (yapıştırma dahil) değeri rakam-dışı
 * karakterlerden temizler ve baştaki sıfırları atar (bkz. lib/numericInput.js).
 *
 * `value`/`onChange` HER ZAMAN temiz, noktasız bir rakam dizisi taşır (ör.
 * "5000000") - bu, ilgili form alanının state'inde tutulan ve API'ye giden
 * gerçek değerdir, hiç değişmedi. `thousands` açıkken SADECE ekranda Türkçe
 * binlik ayraçla ("5.000.000") gösterilir; "Yıl" gibi alanlarda bu prop hiç
 * verilmez (varsayılan false), yanlışlıkla her sayı alanına binlik ayraç
 * uygulanmaz.
 */
export const NumericInput = ({ value, onChange, thousands = false, ...props }) => {
  const clean = toCleanNumericString(value);
  const display = thousands ? formatTurkishThousands(clean) : clean;

  const handleChange = (e) => {
    onChange(sanitizeNumericDigits(e.target.value));
  };

  return <Input {...props} type="text" inputMode="numeric" value={display} onChange={handleChange} />;
};
